// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-counter{display:flex;justify-content:flex-end;align-items:center}.product-counter__button{margin-right:12px;flex:1 1 auto;flex-grow:0}.product-counter__counter{flex:1 1 104px;min-width:104px;max-width:104px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
